import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Brokers from '../views/Brokers/Index.vue'
import Broker from '../views/Brokers/Show.vue'
import NewBroker from '../views/Brokers/New.vue'
import Meetings from '../views/Meetings/Index.vue'
import NewMeeting from '../views/Meetings/New.vue'
import EditMeeting from '../views/Meetings/editForm.vue'
import MeetingDetails from '../views/Meetings/Show.vue'
import PastUpcomingMeeting from '../views/Meetings/past_upcoming.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/Passwords/ResetPassword.vue'
import Brokeredit from '../views/Brokers/editForm.vue'
import Empanelment from '../views/Empanelment/Index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Brokers',
    name: 'Brokers',
    component: Brokers
  },
  {
    path: '/Brokers/New',
    name: 'NewBroker',
    component: NewBroker
  },
  {
    path: '/Broker/:id/edit',
    name: 'Brokeredit',
    component: Brokeredit
  },
  {
    path: '/Broker/:id',
    name: 'Broker',
    component: Broker
  },
  {
    path: '/Meetings',
    name: 'Meetings',
    component: Meetings
  },
  {
    path: '/Meetings/New',
    name: 'NewMeeting',
    component: NewMeeting
  },
  {
    path: '/updateMeeting/:uuid',
    name: 'editMeeting',
    component: EditMeeting
  },
  {
    path: '/Meeting/:id',
    name: 'MeetingDetails',
    component: MeetingDetails
  },
  {
    path: '/Meetings/:meeting_type',
    name: 'PastUpcomingMeeting',
    component: PastUpcomingMeeting
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/Password/Edit',
    name: 'PasswordEdit',
    component: ResetPassword
  },
  {
    path: '/Empanelment',
    name: 'Empanelment',
    component: Empanelment
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
